import { Input } from "antd";
import styles from "../styles.module.scss";

const { TextArea } = Input;

const CustomTextarea = ({
  title,
  placeholder = "-",
  value,
  onChange,
  style,
  onKeyDown,
  autoFocus = false,
  prefix,
  required,
  showCount,
  maxLength,
  readOnly = false,
  allowClear = false,
}) => {
  return (
    <div className="d-flex flex-column gap-1">
      {title && (
        <div className={styles.title}>
          {required && <span>*</span>}
          {title}
        </div>
      )}

      <TextArea
        readOnly={readOnly}
        autoFocus={autoFocus}
        showCount={showCount}
        maxLength={maxLength}
        value={value}
        onChange={onChange}
        prefix={prefix}
        placeholder={placeholder}
        style={{ ...style, minHeight: "100px" }}
        onKeyDown={onKeyDown}
        allowClear={allowClear}
        // disabled={readOnly}
      />
    </div>
  );
};

export default CustomTextarea;
